<template>
  <div class="card p-3">
    <h1 class="text-3xl font-bold mb-4">Info Cmor Giornaliere</h1>
    <div class="grid">
      <div class="col-12 flex justify-content-between align-items-center">
        <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" />
        <div class="flex gap-2">
           <Button label="Riepilogo Risposte" @click="openRiepilogoDialog" icon="pi pi-list" iconPos="left" class="p-button-info mr-3" />
          <input type="file" ref="fileInput" @change="onFileSelect" style="display: none" accept=".csv,.txt" />
          <Button label="Importa Risposte" @click="triggerFileInput" icon="pi pi-upload" iconPos="left" class="p-button-secondary" />
        </div>
      </div>
    </div>

    <div v-if="loading" class="mt-4">
      <p>Caricamento dati in corso...</p>
    </div>

    <div v-else-if="error" class="mt-4">
      <p class="text-red-500">{{ error }}</p>
    </div>

    <div v-else-if="!hasData" class="mt-4">
      <p>Nessun dato disponibile. Utilizza il pulsante Cerca per visualizzare i dati.</p>
    </div>

    <div v-else class="mt-4">
      <div class="flex align-items-center gap-4 mb-4 p-2 border-1 border-round surface-border">
        <span class="font-bold">Legenda:</span>
        <div class="flex align-items-center gap-2">
          <div class="w-2rem h-1rem border-round ml-2 mr-2" style="background-color: #eeeefb"></div>
          <span>Template CMOR inviato</span>
        </div>
      </div>

      <Accordion :multiple="true">
        <AccordionTab header="PODS">
          <DataTable
            :value="allPods"
            dataKey="id"
            responsiveLayout="scroll"
            class="p-datatable-sm mb-4"
            v-model:selection="selectedPods"
            selectionMode="multiple"
            :rowClass="getRowClass"
            :paginator="true"
            :rows="20"
          >
            <Column selectionMode="multiple" :exportable="false" style="width: 3rem"></Column>
            <Column field="code" header="Fornitura"></Column> 
            <Column field="cliente" header="Cliente"></Column>
            <Column field="totale_fattura" header="Totale Fattura">
              <template #body="{ data }">
                {{ data.totale_fattura.toFixed(2) }}
              </template>
            </Column>
            <Column field="pagato" header="Pagato">
              <template #body="{ data }">
                {{ data.pagato.toFixed(2) }}
              </template>
            </Column>
            <Column field="saldo" header="Saldo">
              <template #body="{ data }">
                {{ data.saldo.toFixed(2) }}
              </template>
            </Column>
            <Column field="data_inizio" header="Data Inizio" sortable></Column>
            <Column field="data_fine" header="Data Fine" sortable></Column>
            <Column field="data_invio_messa_in_mora" header="Data Invio Messa In Mora" sortable></Column>
            <Column field="data_invio_cmor_template" header="Data Invio Template Cmor" sortable></Column>
            <Column field="rappresentante" header="Rappresentante"></Column>
            <Column field="piva" header="P.iva"></Column>
            <Column field="codfis" header="C.Fiscale"></Column>
            <Column field="type_client" header="Tipo Cliente"></Column>
            <Column field="email" header="Email"></Column>
            <Column field="pec" header="PEC"></Column>
            <Column field="agente" header="Agente"></Column>
            <Column field="udd" header="Udd"></Column>
            <Column field="udd" header="Nell'ultimo anno udd con">
                  <template #body="{ data }">
                    <span v-if="'id' in data.rcus">
                      {{ data.rcus.udd }} - {{ formatDate(data.rcus.data_fine) }}
                    </span>
                  </template>
                </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="PDRS">
          <DataTable
            :value="allPdrs"
            dataKey="id"
            responsiveLayout="scroll"
            class="p-datatable-sm mb-4"
            v-model:selection="selectedPdrs"
            selectionMode="multiple"
            :rowClass="getRowClass"
            :paginator="true"
            :rows="20"
          >
            <Column selectionMode="multiple" :exportable="false" style="width: 3rem"></Column>
            <Column field="code" header="Fornitura"></Column>
            <Column field="cliente" header="Cliente"></Column>
            <Column field="totale_fattura" header="Totale Fattura">
              <template #body="{ data }">
                {{ data.totale_fattura.toFixed(2) }}
              </template>
            </Column>
            <Column field="pagato" header="Pagato">
              <template #body="{ data }">
                {{ data.pagato.toFixed(2) }}
              </template>
            </Column>
            <Column field="saldo" header="Saldo">
              <template #body="{ data }">
                {{ data.saldo.toFixed(2) }}
              </template>
            </Column>
            <Column field="data_inizio" header="Data Inizio" sortable></Column>
            <Column field="data_fine" header="Data Fine" sortable></Column>
            <Column field="data_invio_messa_in_mora" header="Data Invio Messa In Mora" sortable></Column>
            <Column field="data_invio_cmor_template" header="Data Invio Template Cmor" sortable></Column>
            <Column field="rappresentante" header="Rappresentante"></Column>
            <Column field="piva" header="P.iva"></Column>
            <Column field="codfis" header="C.Fiscale"></Column>
            <Column field="type_client" header="Tipo Cliente"></Column>
            <Column field="email" header="Email"></Column>
            <Column field="pec" header="PEC"></Column>
            <Column field="agente" header="Agente"></Column>
            <Column field="udd" header="Udd"></Column>
            <Column field="udd" header="Nell'ultimo anno udd con">
                  <template #body="{ data }">
                    <span v-if="'id' in data.rcus">
                      {{ data.rcus.udd }} - {{ formatDate(data.rcus.data_fine) }}
                    </span>
                  </template>
                </Column>
          </DataTable>
        </AccordionTab>
      </Accordion>
    </div>

    <div v-show="selectedItems.length > 0" class="btn-selected mb-2">
      <Button @click="generateAndSendFileCmor" class="p-button-warning p-3 m-1" style="min-width:200px">
        Invia template cmor ({{ selectedItems.length }}) <i class="pi pi-send ml-5"></i>
      </Button>

    </div>

    <Dialog v-model:visible="showRiepilogoDialog" header="Riepilogo Risposte CMOR" :modal="true" style="width: 80vw;">
      <div class="mb-3">
        <div class="flex flex-wrap gap-2">
          <Button v-for="date in riepilogoDates" :key="date" :label="formatDate(date)" @click="fetchRiepilogoData(date)" class="p-button-outlined" />
        </div>
      </div>

      <div v-if="riepilogoLoading">
        <p>Caricamento riepilogo...</p>
      </div>
      <div v-else-if="riepilogoData">
        <h4 class="mb-3">Risultati per il {{ riepilogoData.date }}</h4>
        <Accordion :multiple="true" :activeIndex="[0,1]">
          <AccordionTab :header="'OK (' + riepilogoData.ok.count + ' records)'">
              <DataTable ref="dtOk" :value="processedOkDetails" responsiveLayout="scroll" :paginator="true" :rows="10">
                <template #header>
                    <div class="flex justify-content-end">
                        <Button icon="pi pi-download" label="Esporta" @click="exportOkData" class="p-button-success"/>
                    </div>
                </template>
                <Column field="Code" header="Code"></Column>
                <Column field="CP_GESTORE" header="Codice Protocollo"></Column>
                 <Column field="cliente" header="Cliente"></Column>
                 <Column field="rappresentante" header="Rappresentante"></Column>
                 <Column field="udd" header="Udd"></Column>
                 <Column field="saldo" header="Saldo"></Column>  
              </DataTable>
          </AccordionTab>
          <AccordionTab :header="'KO (' + riepilogoData.ko.count + ' records)'">
             <DataTable ref="dtKo" :value="processedKoDetails" responsiveLayout="scroll" :paginator="true" :rows="10">
                <template #header>
                    <div class="flex justify-content-end">
                        <Button icon="pi pi-download" label="Esporta" @click="exportKoData" class="p-button-danger"/>
                    </div>
                </template>
                <Column field="Code" header="Code"></Column>
                <Column field="COD_CAUSALE" header="Causale"></Column>
                <Column field="MOTIVAZIONE" header="Motivazione"></Column>
                 <Column field="cliente" header="Cliente"></Column>
                 <Column field="rappresentante" header="Rappresentante"></Column>
                 <Column field="udd" header="Udd"></Column>
                 <Column field="saldo" header="Saldo"></Column>
              </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
    </Dialog>

  </div>
</template>

<script>
import Service from '@/services/ask-pratiche/pratiche-service'
// import MessaInMoraService from '@/services/ask-management/messa-in-mora-fatture-clienti-service'
import { ref, computed, getCurrentInstance} from 'vue';
import moment from 'moment';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import Dialog from 'primevue/dialog';
// eslint-disable-next-line vue/no-unused-components

export default {
  components: {
    Accordion,
    AccordionTab,
    DataTable,
    Column,
    Button,
    Dialog,
  },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
   // const serviceMessaInMora = new MessaInMoraService(self.$http, self.$eventBus)
    const items = ref(null)
    const loading = ref(false)
    const error = ref(null)
    const selectedDate = ref([moment().format('YYYY-MM-DD')])
    const typeFornitura = ref('TUTTI')
    const saldo = ref(10)
    const agente = ref('TUTTI')
    const selectedPods = ref([])
    const selectedPdrs = ref([])
    const selectedItems = computed(() => [...selectedPods.value, ...selectedPdrs.value])
    const toast = useToast();
    const dialogBeforePecSent = ref(false)
    const dialogCheckPecSent = ref(false)
    const report = ref()
    const fileInput = ref(null);

    const showRiepilogoDialog = ref(false);
    const riepilogoDates = ref([]);
    const riepilogoData = ref(null);
    const riepilogoLoading = ref(false);
    const dtOk = ref();
    const dtKo = ref();

    const processedOkDetails = computed(() => {
      if (!riepilogoData.value?.ok?.details) return [];
      return riepilogoData.value.ok.details.map(item => {
        let code = item.COD_POD || item.COD_PDR;
        if (item.COD_PDR) {
            code = String(item.COD_PDR).padStart(14, '0');
        }
        return {
          ...item,
          Code: code,
          saldo: typeof item.saldo === 'number' ? item.saldo.toFixed(2) : item.saldo
        };
      });
    });

    const processedKoDetails = computed(() => {
      if (!riepilogoData.value?.ko?.details) return [];
      return riepilogoData.value.ko.details.map(item => {
        let code = item.COD_POD || item.COD_PDR;
        if (item.COD_PDR) {
            code = String(item.COD_PDR).padStart(14, '0');
        }
        return {
          ...item,
          Code: code,
          saldo: typeof item.saldo === 'number' ? item.saldo.toFixed(2) : item.saldo
        };
      });
    });

    const allPods = computed(() => {
      if (!items.value?.pods) return []
      return Object.values(items.value.pods).flatMap(agente => agente.forniture)
    })

    const allPdrs = computed(() => {
      if (!items.value?.pdrs) return []
      return Object.values(items.value.pdrs).flatMap(agente => agente.forniture)
    })

    const hasData = computed(() => {
      return items.value && (hasPods.value || hasPdrs.value)
    })

    const hasPods = computed(() => {
      return allPods.value.length > 0
    })

    const hasPdrs = computed(() => {
      return allPdrs.value.length > 0
    })

    const searchData = async () => {
      loading.value = true
      error.value = null

      try {
        const response = await service.getFornitureInCmorAutomatizzato(
          typeFornitura.value,
          selectedDate.value,
          saldo.value,
          agente.value
        )
      
        items.value = response.items
      } catch (err) {
        console.error('Errore nel recupero delle forniture:', err)
        error.value = 'Si è verificato un errore durante il recupero dei dati. Riprova più tardi.'
      } finally {
        loading.value = false
      }
    }

    const generateAndSendFileCmor = () => {
      loading.value = true;
      service.generateAndSendFileCmorAutomatizzato(selectedItems.value)
        .then((res) => {
          if (res.items) {
            toast.add({ severity: 'success', summary: 'Successo', detail: 'Template inviato', life: 3000 });
            selectedPods.value = [];
            selectedPdrs.value = [];
            searchData();
          } else {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore generazione e invio template' });
          }
        }).finally(() => {
          loading.value = false;
        });
    }

    const openRiepilogoDialog = async () => {
      showRiepilogoDialog.value = true;
      riepilogoData.value = null;
      try {
        riepilogoDates.value = await service.riepilogoCmorResponse();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare le date per il riepilogo.', life: 3000 });
      }
    };

    const fetchRiepilogoData = async (date) => {
      riepilogoLoading.value = true;
      riepilogoData.value = null;
      try {
        riepilogoData.value = await service.riepilogoCmorResponse(date);
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare il riepilogo per la data selezionata.', life: 3000 });
      } finally {
        riepilogoLoading.value = false;
      }
    };

    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const onFileSelect = async (event) => {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      loading.value = true;
      error.value = null;

      try {
        const response = await service.importCmorResponse(file);
        if (response.items.success) {
          toast.add({ severity: 'success', summary: 'Successo', detail: response.items.message, life: 3000 });
          searchData(); 
        } else {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: response.items.message, life: 5000 });
        }
      } catch (err) {
        console.error('Errore nell\'importazione del file:', err);
        const errorMessage = err.response?.data?.message || 'Si è verificato un errore durante l\'importazione del file.';
        toast.add({ severity: 'error', summary: 'Errore', detail: errorMessage, life: 5000 });
        error.value = errorMessage;
      } finally {
        loading.value = false;
        event.target.value = '';
      }
    };

    function getMonthName(month) {
      const m = moment().locale('en').month(month.toLowerCase()).month();
      return moment().month(m).locale('it').format('MMMM').toUpperCase();
    }

    const getRowClass = (data) => {
      return {
        'row-template-sent': data.template_inviato === 1
      };
    };

    const exportOkData = () => {
        dtOk.value.exportCSV();
    };

    const exportKoData = () => {
        dtKo.value.exportCSV();
    };

    return {
      searchData,
      items,
      loading,
      error,
      hasData,
      hasPods,
      hasPdrs,
      allPods,
      allPdrs,
      selectedDate,
      typeFornitura,
      saldo,
      agente,
      moment,
      formatDate,
      getMonthName,
      selectedItems,
      selectedPods,
      selectedPdrs,
      generateAndSendFileCmor,
      dialogBeforePecSent,
      dialogCheckPecSent,
      report,
      getRowClass,
      fileInput,
      triggerFileInput,
      onFileSelect,
      showRiepilogoDialog,
      riepilogoDates,
      riepilogoData,
      riepilogoLoading,
      openRiepilogoDialog,
      fetchRiepilogoData,
      dtOk,
      dtKo,
      exportOkData,
      exportKoData,
      processedOkDetails,
      processedKoDetails
    }
  }
}
</script>

<style scoped>
.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 0.5rem;
  font-size: 0.875rem;
}

.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0.5rem;
  font-size: 0.875rem;
}

.btn-selected {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 2;
}

:deep(.p-datatable) .row-template-sent {
  background-color: #eeeefb !important;
}

</style>